import actions from "./actions.organizations"
import getters from "./getters.organizations"
import mutations from "./mutations.organizations"

export interface CatOrganization {
  id: string
  name: string
  status: string
  appIds: string[]
  createdAt: string
  updatedAt: string
}

export interface OrgAppId {
  id: string
  appId: string
  catOrganizationId: string
  status: string
  createdAt: string
  updatedAt: string
}

export interface OrgClientId {
  id: string
  clientId: string
  catOrganizationId: string
  createdAt: string
  updatedAt: string
}

export interface OrgUser {
  id: string
  name: string
  firstname: string
  lastname: string
  email: string
  role: string
  catOrganizationId: string
  country: string
  createdAt: string
}

export interface OrganizationsState {
  organizations: CatOrganization[]
  selectedOrganization: CatOrganization | null
  orgAppIds: OrgAppId[]
  orgClientIds: OrgClientId[]
  orgUsers: OrgUser[]
  loading: boolean
  loadingAppIds: boolean
  loadingClientIds: boolean
  loadingUsers: boolean
}


export const state: OrganizationsState = {
  organizations: [],
  selectedOrganization: null,
  orgAppIds: [],
  orgClientIds: [],
  orgUsers: [],
  loading: false,
  loadingAppIds: false,
  loadingClientIds: false,
  loadingUsers: false,
}

const Organizations = {
  namespaced: true as true,
  state,
  getters,
  mutations,
  actions,
}

export default Organizations
